import { Box, Grid } from "@material-ui/core";
import { TrashIcon } from "App/Assets";
import { IconButtonDatatable, MasterButton } from "App/Component/ui";
import { instance1, instance2 } from "App/constants";
import { getUserID, setThema } from "App/utils/cookies";
import {
  defaultToastError,
  defaultToastSuccess,
  isNull,
} from "App/utils/helpers";
import { useDispatchWrapper } from "hooks";
import React, { useRef, useState, useEffect } from "react";
import { deleteTemaById } from "../Tema/helpers";
import { changeTheme } from "./context/actions";

function WrapperColorTheme() {
  const { state, dispatch } = useDispatchWrapper();
  const themeList = state.theme_list;

  const refThemeList = useRef(null);
  const [disabled, setDisabled] = useState(false);

  const [rows, setRows] = useState([]);

  const getThemeByUser = async () => {
    try {
      const res = await instance1.get("/theme/by_id", {
        headers: {
          user_id: getUserID(),
        },
      });

      setRows(res.data.body);
    } catch (error) {}
  };

  useEffect(() => {
    getThemeByUser();
  }, []);

  const handleChange = (text) => (e) => {
    dispatch(
      changeTheme({
        ...themeList,
        [text]: e.target.value,
      })
    );
  };

  const handleChangeColor = (e) => {
    changeTextSidebar(e.target.value);
    dispatch(
      changeTheme({
        ...themeList,
        sidebar_color: e.target.value,
      })
    );
  };

  const handleChangeColorNavBar = (e) => {
    changeTextTopBar(e.target.value);
    dispatch(
      changeTheme({
        ...themeList,
        header_color: e.target.value,
      })
    );
  };

  const handleClickButtonTheme = () => {
    if (!refThemeList.current.classList.contains("show")) {
      refThemeList.current.classList.add("show");
    } else {
      refThemeList.current.classList.remove("show");
    }
  };

  const handleChangeCard = (e) => {
    changeCardBackground(e.target.value);
    dispatch(
      changeTheme({
        ...themeList,
        card_background: e.target.value,
      })
    );
  };

  const changeTextSidebar = (color) => {
    const navItem = document.querySelectorAll(".navigation-item a");
    const arrowItem = document.querySelectorAll("span.arrow");

    for (let i = 0; i < navItem.length; i++) {
      navItem[i].style.color = color;
    }

    for (let i = 0; i < arrowItem.length; i++) {
      arrowItem[i].style.borderColor = color;
    }
  };

  const changeTextTopBar = (color) => {
    const topNavItem = document.querySelectorAll(".top-nav-bars");
    for (let i = 0; i < topNavItem.length; i++) {
      topNavItem[i].style.color = color;
    }
  };

  const changeCardBackground = (color) => {
    const card = document.querySelectorAll(".MuiPaper-root");
    for (let i = 0; i < card.length; i++) {
      card[i].setAttribute("style", `background:${color} !important;`);
    }
  };

  const handleClickDefault = (row) => {
    changeTextSidebar(row?.json.sidebar_color);
    changeTextTopBar(row?.json.header_color);
    changeCardBackground(row?.json.card_background);
    dispatch(changeTheme(row?.json));
    setThema(JSON.stringify(row.json));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(true);
    try {
      await instance2.post("/users/set-default-tema-user", {
        theme: themeList,
      });

      defaultToastSuccess("Berhasil disimpan");
      setDisabled(false);
    } catch (error) {
      defaultToastError(error?.response?.data?.message);
      setDisabled(false);
    }
  };

  const handleClickAdd = async () => {
    try {
      await instance1.post("/theme/add", {
        user_id: getUserID(),
        title: themeList.title,
        json: themeList,
      });
      defaultToastSuccess("Berhasil disimpan");
      await getThemeByUser();
    } catch (error) {
      defaultToastError(error?.response?.data?.message);
    }
  };

  const handleClickDelete = async (id) => {
    const response = await deleteTemaById(id);
    if (response.state) {
      defaultToastSuccess(response.message);
      await getThemeByUser();
    } else {
      defaultToastError(response.message);
    }
  };

  return (
    <div className='color-theme'>
      <div className='color-theme-wrap'>
        <div className='color-theme-button' onClick={handleClickButtonTheme}>
          <button type='button'>
            <i className='fas fa-cogs'></i>
          </button>
        </div>

        <div className='color-theme-list' ref={refThemeList}>
          <form onSubmit={(e) => handleSubmit(e)}>
            <Grid container spacing={1}>
              <Grid item sm={12}>
                <div className='form-group-color'>
                  <label htmlFor='sidebar_background'>Nama Tema</label>
                  <input
                    style={{
                      padding: "0.35rem 0 0.35rem 0.3rem",
                      fontSize: "10px",
                      outline: "none",
                      width: "100%",
                    }}
                    id='title'
                    name='title'
                    type='text'
                    value={themeList.title}
                    onChange={handleChange("title")}
                  />
                </div>
              </Grid>
              <Grid item sm={6}>
                <div className='form-group-color'>
                  <label htmlFor='sidebar_background'>Sidebar Background</label>
                  <input
                    id='sidebar_background'
                    name='sidebar_background'
                    type='color'
                    value={themeList.sidebar_background}
                    onChange={handleChange("sidebar_background")}
                  />
                </div>
              </Grid>
              <Grid item sm={6}>
                <div className='form-group-color'>
                  <label htmlFor='sidebar_color'>Sidebar Font</label>
                  <input
                    id='sidebar_color'
                    name='sidebar_color'
                    type='color'
                    value={themeList.sidebar_color}
                    onChange={handleChangeColor}
                  />
                </div>
              </Grid>

              <Grid item sm={6}>
                <div className='form-group-color'>
                  <label htmlFor='header'>Header Background</label>
                  <input
                    id='header'
                    name='header'
                    type='color'
                    value={themeList.header}
                    onChange={handleChange("header")}
                  />
                </div>
              </Grid>

              <Grid item sm={6}>
                <div className='form-group-color'>
                  <label htmlFor='header_color'>Header Font</label>
                  <input
                    id='header_color'
                    name='header_color'
                    type='color'
                    value={
                      isNull(themeList?.header_color)
                        ? "#797979"
                        : themeList?.header_color
                    }
                    onChange={handleChangeColorNavBar}
                  />
                </div>
              </Grid>

              <Grid item sm={6}>
                <div className='form-group-color'>
                  <label htmlFor='tab'>Tab Background</label>
                  <input
                    id='tab'
                    name='tab'
                    type='color'
                    value={isNull(themeList.tab) ? "#979797" : themeList?.tab}
                    onChange={handleChange("tab")}
                  />
                </div>
              </Grid>
              <Grid item sm={6}>
                <div className='form-group-color'>
                  <label htmlFor='tab_color'>Tab Font</label>
                  <input
                    id='tab_color'
                    name='tab_color'
                    type='color'
                    value={
                      isNull(themeList?.tab_color)
                        ? "#FFFFFF"
                        : themeList?.tab_color
                    }
                    onChange={handleChange("tab_color")}
                  />
                </div>
              </Grid>

              <Grid item sm={6}>
                <div className='form-group-color'>
                  <label htmlFor='tab_active'>Tab Active Background</label>
                  <input
                    id='tab_active'
                    name='tab_active'
                    type='color'
                    value={
                      isNull(themeList?.tab_active)
                        ? "#52525B"
                        : themeList.tab_active
                    }
                    onChange={handleChange("tab_active")}
                  />
                </div>
              </Grid>

              <Grid item sm={6}>
                <div className='form-group-color'>
                  <label htmlFor='tab_active_color'>Tab Active Font</label>
                  <input
                    id='tab_active_color'
                    name='tab_active_color'
                    type='color'
                    value={
                      isNull(themeList?.tab_active_color)
                        ? "#FFFFFF"
                        : themeList.tab_active_color
                    }
                    onChange={handleChange("tab_active_color")}
                  />
                </div>
              </Grid>

              <Grid item sm={6}>
                <div className='form-group-color'>
                  <label htmlFor='wrapper'>Root Background</label>
                  <input
                    id='wrapper'
                    name='wrapper'
                    type='color'
                    value={themeList.wrapper}
                    onChange={handleChange("wrapper")}
                  />
                </div>
              </Grid>

              <Grid item sm={6}>
                <div className='form-group-color'>
                  <label htmlFor='card_background'>Card Background</label>
                  <input
                    id='card_background'
                    name='card_background'
                    type='color'
                    value={themeList.card_background}
                    onChange={handleChangeCard}
                  />
                </div>
              </Grid>
            </Grid>
            <div className='mt-2'>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  justifyContent: "flex-end",
                }}>
                <MasterButton
                  type='submit'
                  color={disabled ? "secondary" : "warning"}
                  name={disabled ? "Loading..." : "Jadikan Default Tema"}
                  size='lg'
                />

                <MasterButton
                  onClick={() => handleClickAdd()}
                  type='button'
                  color={"green"}
                  name={"Simpan"}
                  size='lg'
                />
              </div>
            </div>
          </form>
          <div className='mt-2'>
            <p>Tema yang tersimpan</p>
            <Box>
              <Grid
                container
                // spacing={1}
                style={{
                  gap: "10px",
                  marginTop: "1rem",
                }}>
                {rows.map((row, index) => {
                  return (
                    <Grid item sm={12} key={index}>
                      <Grid container spacing={1}>
                        <Grid
                          item
                          sm={10}
                          onClick={() => handleClickDefault(row)}
                          style={{
                            backgroundColor: `${row?.json?.sidebar_background}`,
                            color: `${row?.json?.sidebar_color}`,
                            cursor: "pointer",
                            fontSize: "10px",
                            textAlign: "center",
                            fontWeight: 600,
                            borderRadius: "4px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}>
                          {row.title}
                        </Grid>

                        <Grid item sm={2}>
                          <IconButtonDatatable
                            onClick={() => handleClickDelete(row.id)}
                            style={{
                              background: "transparent",
                            }}>
                            <TrashIcon fill='red' />
                          </IconButtonDatatable>
                        </Grid>
                      </Grid>
                    </Grid>
                  );
                })}
              </Grid>
            </Box>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WrapperColorTheme;
